import { Media } from './media';
import { DatabaseModel, ModelJson } from './database-model';
import { SectionColor } from './page-section';

export enum InfoSectionType {
    SPLIT_MEDIA_LEFT = 'SPLIT_MEDIA_LEFT',
    SPLIT_MEDIA_RIGHT = 'SPLIT_MEDIA_RIGHT',
    CENTER = 'CENTER',
    MAP = 'MAP'
}

export enum InfoActionType {
    BUY = 'BUY',
    START_TOUR = 'START_TOUR',
    SHOW_TRAILER = 'SHOW_TRAILER',
    SCROLL_TO_SNEAK_PEEK = 'SCROLL_TO_SNEAK_PEEK',
    SCROLL_TO_PRODUCTS = 'SCROLL_TO_PRODUCTS',
    OPEN_MAP = 'OPEN_MAP'
}

export class TourInfoSection extends DatabaseModel {
    public key: string;
    public title: string = '';
    // Section layout (split with media left/right or content in center)
    public type: InfoSectionType;
    // Paragraphs
    public paragraphs: string[] = [];
    // Description of tour creator
    public creatorParagraph: string = '';
    // Icons to appear before each paragraph
    public icons: string[] = [];
    // Button properties
    public actions: { type: InfoActionType, label: string, style: 'button-filled' | 'button-outline' }[] = [];
    // Background/text/button color theme
    public color: SectionColor
    // Set true to add number before each paragraph
    public numberedList: boolean;
    // Set true to stack sub-sections in reverse order (applies to split sections)
    public wrapReverse: boolean;
    // Set true to show tour products
    public showProducts: boolean;
    // Set redirect url for media click
    public mediaRedirect: string = '';
    // List of expandable/collapsable boxes
    public expandableBoxes: { title: string, content: string, isOpen: boolean }[] = [];

    /** 
     * Media Array (mark as map when transformed to firebase schema) 
     * @asType object 
     * @additionalProperties { "$ref": "#/definitions/Media" } 
     */
    public mediaArray: Media[] = [];
    public media: Media = null;

    constructor(json: any = null, key?: string) {
        super();
        if(json) this.fromJson(json);
        // Automatically assign keys to new objects
        if(!this.key) this.key = key || this.genKey();
    }

    public fromJson(json): TourInfoSection {
        Object.assign(this, json);
        // Map media json to instances
        this.media = json.media ? new Media(json.media) : null;
        this.mediaArray = this.fromJsonMapToArray(json.mediaArray, Media);
        // Convert paragraph from map as it is auto converted to map (by FB or Object.assign?)
        this.paragraphs = json.paragraphs ? DatabaseModel.mapToArray(json.paragraphs) : [];
        this.icons = json.icons ? DatabaseModel.mapToArray(json.icons) : [];
        return this;
    }

    public toJson() {
        let json = Object.assign({}, this);
        // Map special objects to json
        (json.media as ModelJson) = this.media ? this.media.toJson() : null;
        (json.mediaArray as ModelJson) = this.toJsonMapFromArray(this.mediaArray);

        return json;
    }
}
